import { Box } from '@mui/material';
import { FC } from 'react';

import { TDocumentMetadata } from '@/types/document';

import { GoogleDriveIcon } from '@/assets/icons/GoogleDriveIcon';

interface FileIconWithOverlayProps {
  FileIcon: React.ComponentType;
  metadata?: TDocumentMetadata;
  description?: string; // For folders synced from Google Drive
}

const FileIconWithOverlay: FC<FileIconWithOverlayProps> = ({ FileIcon, metadata, description }) => {
  const hasGoogleDriveMetadata = !!metadata?.google_drive_id;
  const isGoogleDriveFolder = !!description?.includes('Synced from Google Drive folder:');
  const showGoogleDriveOverlay = hasGoogleDriveMetadata || isGoogleDriveFolder;

  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <FileIcon />
      {showGoogleDriveOverlay && (
        <Box
          sx={{
            position: 'absolute',
            bottom: -2,
            right: -2,
            width: 12,
            height: 12,
            borderRadius: '50%',
            backgroundColor: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
          }}
        >
          <GoogleDriveIcon sx={{ fontSize: 10 }} />
        </Box>
      )}
    </Box>
  );
};

export default FileIconWithOverlay;
